import React, { memo } from "react";
import { LoadingIndicator } from "../../../../../../components";
import { Title } from "../../../../../../components/dynamicanalysis";
import LoadingAndErrorBoundary from "../../../../../commons/LoadingAndErrorBoundary";
import MutexGrid from "./MutexGrid";

const Mutexes = () => (
  <>
    <Title headingLevel="h2" title="Mutexes" />
    <LoadingAndErrorBoundary
      errorFallback={() => <div>No mutexes.</div>}
      suspenseFallback={
        <LoadingIndicator data-testid={"mutex-loading-indicator"} />
      }
    >
      <MutexGrid />
    </LoadingAndErrorBoundary>
  </>
);

export default memo(Mutexes);
